import { useState } from 'react';

import { WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useSharedResourcesStore } from 'store/sharedResources.store';

import { useSharedResourcesAvailability } from 'api/queries/sharedResourcesAvailability.query';

import { IClusterItem } from 'components/widgets/Gantt/components/ganttChart.types';

export const useSharedResourcesAvailabilityProvider = ({ widgetId, latestVersionId, localFilters, widgetViewMode }) => {
    const isInPinboard = Boolean(widgetId);
    const isEditingWidget = WidgetViewModeUtils.isReportEditWidget(widgetViewMode);

    const [cluster, setCluster] = useCLusterState({ isEditingWidget, localFilters });

    const [isCriticalPath, setIsCriticalPath] = useState<boolean>(
        isEditingWidget ? localFilters?.isCriticalPath : false,
    );

    const source = isInPinboard ? localFilters : { cluster, isCriticalPath };

    return {
        ui: {
            state: getState({ source }),
            pills: useGetPills(source, widgetId, latestVersionId),
            setters: {
                setCluster,
                setIsCriticalPath,
            },
            isInPinboard,
        },
        api: {
            getSharedResourcesAvailability: {
                instance: useSharedResourcesAvailability({ lastMetaDataId: latestVersionId }),
                payload: { lastMetaDataId: latestVersionId },
            },
        },
    };
};

const useGetPills = (source, widgetId, latestVersionId) => {
    const pillsData = {
        cluster: source?.cluster?.label,
        isCriticalPath: source?.isCriticalPath,
    };

    const { pillsList: pills } = useGlobalFiltersHook({
        widgetId,
        latestVersionId,
        source: pillsData,
    });

    return pills;
};

const getState = ({ source }) => {
    return {
        //local
        cluster: source?.cluster,
        isCriticalPath: source?.isCriticalPath,
    };
};

const useCLusterState = ({
    isEditingWidget,
    localFilters,
}): [IClusterItem | null, (value: IClusterItem | null) => void] => {
    //cluster state that is connected to persistent store
    const [cluster, setCluster] = useState<IClusterItem | null>(isEditingWidget ? localFilters?.cluster : null);
    const { update } = useSharedResourcesStore();

    const handleClusterSelect = (value: IClusterItem | null) => {
        setCluster(value);
        update({ cluster: value });
    };

    return [cluster, handleClusterSelect];
};
